<template>
  <div class="enterprise-settings-container">
    <breadcrumb :items="breadcrumbs" class="pa-0 mb-4"></breadcrumb>
    <v-container fluid class="pa-4">
      <v-row no-gutters>
        <!-- Sidebar Navigation -->
        <v-col cols="3" class="pr-4">
          <v-card class="sidebar-nav" elevation="0">
            <v-list nav dense>
               <v-list-item
                :to="{ name: 'enterpriseProfileSettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-account-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Profile Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'enterpriseGeneralSettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>General Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'enterpriseFarmSettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-barn</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Farm Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'enterpriseUOMSettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-scale-balance</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>UOM Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item
                :to="{ name: 'enterpriseCurrencySettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-currency-usd</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Currency Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'enterpriseSecuritySettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-lock</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Security Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'enterpriseNotificationsSettings' }"
                :active-class="activeClass"
                link
                class="nav-item"
              >
                <v-list-item-icon>
                  <v-icon>mdi-bell</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Notifications Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->
            </v-list>
          </v-card>
        </v-col>

        <!-- Main Content Area -->
        <v-col cols="9">
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseSettings',
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/dashboard',
        },
        {
          text: 'Enterprises',
          disabled: false,
          to: '/enterprises',
        },
        {
          text: 'Enterprise Details',
          disabled: false,
          to: '/enterprises',
        },
        {
          text: 'Enterprise Settings',
          disabled: true,
        },
      ],
    };
  },
  computed: {
    activeClass() {
      return 'active-nav-item';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.enterprise-settings-container {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.sidebar-nav {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 8px 0;
}

.nav-item {
  margin: 4px 8px;
  border-radius: 4px;
  
  ::v-deep .v-list-item__icon {
    margin-right: 12px;
  }
}

::v-deep .active-nav-item {
  background-color: $primary-color !important;
  color: white !important;
  
  .v-icon {
    color: white !important;
  }
  
  .v-list-item__title {
    color: white !important;
  }
}

::v-deep .v-list-item__icon {
  min-width: 40px;
}
</style>
